<template>
  <ArrowForward class="arrow-forward" />
</template>
<script>
import ArrowForward from './ArrowForward'
export default {
  components: { ArrowForward }
}
</script>
<style lang="scss" scoped>
.arrow-forward {
  & /deep/ path {
    fill: $primary;
  }
}
</style>
